<mat-horizontal-stepper [linear]="true" #horizontalStepper>
  <mat-step [stepControl]="accountDetailsForm" #horizontalStepperStep1>
    <treo-message
      *ngIf="accountDetailsFormMessage"
      [appearance]="accountDetailsFormMessage.appearance"
      [showIcon]="accountDetailsFormMessage.showIcon"
      [type]="accountDetailsFormMessage.type"
      [@shake]="accountDetailsFormMessage.shake"
    >
      {{ accountDetailsFormMessage.content }}
    </treo-message>
    <form [formGroup]="accountDetailsForm" (ngSubmit)="submitAccountDetailsForm()" #formone="ngForm" autocomplete="off">
      <ng-template matStepLabel>Account Details</ng-template>
      <div class="flex flex-col gt-xs:flex-row gt-xs:items-start">
        <div class="gt-xs:max-w-80 gt-xs:pr-12">
          <p class="text-lg font-medium">Let's create your workspace.</p>
          <p class="text-secondary mb-6">
            A workspace can be thought of as an account. This is where you will login to view and manage your views.
            Each workspace is associated with a subdomain e.g. https://xyz.termsheet.com.
          </p>
        </div>
        <div class="flex-auto min-w-64">
          <div class="flex">
            <mat-form-field class="flex-auto">
              <mat-label class="required-input">What should we call your workspace?</mat-label>
              <input matInput [formControlName]="'name'" [placeholder]="'Company Name or Account Name'" required />
            </mat-form-field>
          </div>
          <div class="flex">
            <mat-form-field class="flex-auto">
              <mat-label class="required-input"
                >What subdomain would you like to use to access your workspace?</mat-label
              >
              <input matInput [formControlName]="'subdomain'" [placeholder]="'Workspace subdomain'" required />
              <span matSuffix>.termsheet.com</span>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="flex justify-end">
        <button
          class="px-8"
          mat-flat-button
          [color]="'primary'"
          [disabled]="accountDetailsForm.pristine || accountDetailsForm.invalid"
          type="submit"
        >
          <span *ngIf="!accountDetailsForm.disabled"> Next </span>
          <mat-progress-spinner
            *ngIf="accountDetailsForm.disabled"
            [diameter]="24"
            [mode]="'indeterminate'"
          ></mat-progress-spinner>
        </button>
      </div>
    </form>
  </mat-step>
  <mat-step [stepControl]="pipelineTemplateForm" #horizontalStepperStep2>
    <treo-message
      *ngIf="pipelineTemplateFormMessage"
      [appearance]="pipelineTemplateFormMessage.appearance"
      [showIcon]="pipelineTemplateFormMessage.showIcon"
      [type]="pipelineTemplateFormMessage.type"
      [@shake]="pipelineTemplateFormMessage.shake"
    >
      {{ pipelineTemplateFormMessage.content }}
    </treo-message>
    <form
      [formGroup]="pipelineTemplateForm"
      (ngSubmit)="submitPipelineTemplateForm()"
      #formtwo="ngForm"
      autocomplete="off"
    >
      <ng-template matStepLabel>Deal View</ng-template>
      <div class="flex flex-col gt-xs:flex-row gt-xs:items-start">
        <div class="gt-xs:max-w-80 gt-xs:pr-12">
          <p class="text-lg font-medium">Let's create your first view.</p>
          <p class="text-secondary mb-6">
            Views are lists that you will use to track your deals. They are completely customizable and allow you to
            track the data that you feel is important. You can modify views at any time as well as add multiple views.
          </p>
        </div>
        <div class="flex-auto min-w-64">
          <div class="flex">
            <mat-form-field class="flex-auto">
              <mat-label
                >What best describe how you will track deals?
                <small class="align-bottom">*You can always change this later</small></mat-label
              >
              <mat-select [formControlName]="'template_id'" (selectionChange)="onPipelineTemplateChange($event)">
                <mat-option [value]="template.id" *ngFor="let template of pipelineTemplates">{{
                  template.name
                }}</mat-option>
              </mat-select>
              <mat-icon matPrefix [svgIcon]="'list'"></mat-icon>
            </mat-form-field>
          </div>
          <div class="flex flex-col my-2" *ngIf="selectedPipelineTemplate" class="flex my-1 flex-row flex-wrap">
            <div *ngFor="let field of selectedPipelineTemplate.body.table.fields" class="template-item flex m-1">
              <ng-container *ngIf="lookupField(field) as fieldDef">
                <mat-icon class="icon-size-20 mr-2" [svgIcon]="'assignment_turned_in'"></mat-icon>
                <span>{{ fieldDef.label }}</span>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
      <div class="flex justify-end">
        <button
          class="px-8"
          mat-flat-button
          [color]="'primary'"
          [disabled]="pipelineTemplateForm.pristine || pipelineTemplateForm.invalid"
          type="submit"
        >
          <span *ngIf="!pipelineTemplateForm.disabled"> Next </span>
          <mat-progress-spinner
            *ngIf="pipelineTemplateForm.disabled"
            [diameter]="24"
            [mode]="'indeterminate'"
          ></mat-progress-spinner>
        </button>
      </div>
    </form>
  </mat-step>
  <mat-step [stepControl]="inviteUserForm" #horizontalStepperStep3>
    <treo-message
      *ngIf="inviteUserFormMessage"
      [appearance]="inviteUserFormMessage.appearance"
      [showIcon]="inviteUserFormMessage.showIcon"
      [type]="inviteUserFormMessage.type"
      [@shake]="inviteUserFormMessage.shake"
    >
      {{ inviteUserFormMessage.content }}
    </treo-message>
    <form [formGroup]="inviteUserForm" autocomplete="off">
      <ng-template matStepLabel>Invite Team</ng-template>
      <div class="flex flex-col gt-xs:flex-row gt-xs:items-start">
        <div class="gt-xs:max-w-80 gt-xs:pr-12">
          <p class="text-lg font-medium">TermSheet is a lot more fun with friends.</p>
          <p class="text-secondary mb-6">
            Invite some other members of your team so they too can share in the joy. If you aren't ready to share or
            want to invite them later you can skip this step.
          </p>
        </div>
        <div class="flex-auto min-w-64">
          <div
            class="flex email"
            *ngFor="let emailFormGroup of inviteUserForm.get('emails')['controls']; let i = index; let first = first"
          >
            <mat-form-field class="flex-auto">
              <input
                matInput
                [formControl]="emailFormGroup.get('email')"
                [placeholder]="'Enter email address of person to invite'"
                required
              />
              <mat-icon matPrefix [svgIcon]="'mail'"></mat-icon>
            </mat-form-field>
            <div class="actions">
              <button
                class="remove-email-field"
                *ngIf="!first"
                type="button"
                mat-icon-button
                (click)="removeEmailField(i)"
                matTooltip="Remove"
              >
                <mat-icon [svgIcon]="'remove_circle'"></mat-icon>
              </button>

              <button class="add-email-field" type="button" mat-icon-button (click)="addEmailField()" matTooltip="Add">
                <mat-icon [svgIcon]="'add_circle'"></mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="flex justify-end">
        <button class="discard-button" mat-button type="button" (click)="skipAndComplete()">
          <span>Skip</span>
        </button>
        <button
          class="px-8"
          mat-flat-button
          [color]="'primary'"
          [disabled]="inviteUserForm.pristine || inviteUserForm.invalid"
          (click)="submitInviteUserForm()"
          type="submit"
        >
          <span *ngIf="!inviteUserForm.disabled"> Invite </span>
          <mat-progress-spinner
            *ngIf="inviteUserForm.disabled"
            [diameter]="24"
            [mode]="'indeterminate'"
          ></mat-progress-spinner>
        </button>
      </div>
    </form>
  </mat-step>
</mat-horizontal-stepper>
